import { Tab } from 'rc-tabs/lib/interface';
import React, { FC } from 'react';

import { StyledTabs } from './styled';

type TProps = {
    items: Tab[];
    activeKey?: string;
    onChange?: (key: string) => void;
};

export const TabsAnt: FC<TProps> = ({ items, activeKey, onChange }) => {
    return <StyledTabs activeKey={activeKey} onChange={onChange} items={items} />;
};
